import React, { forwardRef } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { TextButtonAction } from './TextButtonAction/TextButtonAction';
import { classes, st } from './ActionsToolBar.st.css';
import { Delete, MoveTo, Download } from '@wix/wix-ui-icons-common/on-stage';
import { MODAL_TYPES } from '../../../../../../Constants/Modals.Constants';
import { setOpenedModal } from '../../../../../Services/Modals.service';
import { ACTIONS_TOOLBAR } from '../../../../../../Constants/ActionsToolBar.Constant';
import useObservable from '../../../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedItems } from '../../../../../Services/SelectedItems.service';
import {
  downloadItems,
  getIsDownloadEnabled,
} from '../../../../../Services/ItemsDownload.service';
import MoveWrapper from '../../../../../Shared/MoveWrapper/MoveWrapper';
import withClickOutsideListener from '../../../../../../Shared/HOC/withClickOutsideListener';
import withMemberAuthorization from '../../../../../../Shared/HOC/withMemberAuthorization';
import { getAppSettings } from '../../../../../Services/AppSettings.service';
import { getSelectedFolder } from '../../../../../Services/SelectedFolder.service';
import { getActionAuthStatus } from '../../../TableWrapper/ItemsWrapper/Item/ItemActions/ItemActionsMenu/MenuOptions/helper';
import { ITEM_MENU_OPTIONS } from '../../../../../../Constants/ItemMenu.Constant';

const ActionsToolBar = forwardRef((props: any, ref: any) => {
  const { t } = useTranslation();
  const [, selectedItems]: any = useObservable(getSelectedItems());
  const [, selectedFolder]: any = useObservable(getSelectedFolder());
  const [, isDownloadEnabled]: any = useObservable(getIsDownloadEnabled());
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';
  const { open, setOpen, memberAuthorization } = props;
  const deleteTitle = t('app.widget.actions.toolBar.delete');
  const moveTitle = t('app.widget.actions.toolBar.move');
  const downloadTitle = t('app.widget.actions.toolBar.download');
  const isSelectedFolderValid = () =>
    selectedFolder !== undefined &&
    selectedFolder.libraryItems &&
    selectedFolder.libraryItems.length > 0;

  const getIsDisplayed = (action: string) => {
    return isSelectedFolderValid()
      ? getActionAuthStatus(selectedFolder.libraryItems[0], action)
      : false;
  };

  const actionsToolBarItems = [
    {
      prefixIcon: <Delete />,
      text: deleteTitle,
      type: ACTIONS_TOOLBAR.DELETE,
      isDisplayed: getIsDisplayed(ITEM_MENU_OPTIONS.DELETE),
    },
    {
      prefixIcon: <MoveTo />,
      text: moveTitle,
      type: ACTIONS_TOOLBAR.MOVE,
      isDisplayed: getIsDisplayed(ITEM_MENU_OPTIONS.MOVE),
    },
    {
      prefixIcon: <Download />,
      text: downloadTitle,
      type: ACTIONS_TOOLBAR.DOWNLOAD,
      isDisplayed: true,
    },
  ];
  const handleMove = () => {
    setOpen(true);
  };
  const handleOnClick = (type: string) => {
    switch (type) {
      case ACTIONS_TOOLBAR.DELETE:
        setOpenedModal(MODAL_TYPES.DELETE);
        break;
      case ACTIONS_TOOLBAR.DOWNLOAD:
        if (!isSelectedFolderValid() || !selectedItems?.length) {
          return;
        }
        const fullSelectedItems = selectedFolder?.libraryItems.filter(
          (item: { id: string }) => selectedItems.includes(item.id),
        );
        const downloadAllow = fullSelectedItems.every((item: any) =>
          getActionAuthStatus(item, ITEM_MENU_OPTIONS.DOWNLOAD),
        );
        if (!downloadAllow) {
          memberAuthorization({
            args: [ACTIONS_TOOLBAR.DOWNLOAD],
            callBack: () => downloadItems(t),
          });
        } else {
          selectedItems && downloadItems(t);
        }
        break;
      case ACTIONS_TOOLBAR.MOVE:
        handleMove();
        break;
      default:
        break;
    }
  };

  const generateActionsToolBarItems = () => {
    let isEnabled: boolean = true;
    return actionsToolBarItems.map((actionItem: any) => {
      const isDownloadAction = actionItem.type === ACTIONS_TOOLBAR.DOWNLOAD;
      isEnabled = isDownloadAction
        ? isDownloadEnabled !== undefined && isDownloadEnabled === true
        : true;
      const isDisplayed = actionItem.isDisplayed;
      const isMoveAction = actionItem.type === ACTIONS_TOOLBAR.MOVE;
      const actionButton = isDisplayed ? (
        <TextButtonAction
          isEnabled={isEnabled}
          prefixIcon={actionItem.prefixIcon}
          text={isMobile === false ? actionItem.text : ''}
          onClick={() =>
            isDownloadAction && isEnabled
              ? handleOnClick(actionItem.type)
              : memberAuthorization({
                  args: [actionItem.type],
                  callBack: handleOnClick,
                })
          }
          className={st(classes.TextButtonContainer)}
        />
      ) : null;

      return (
        <div
          className={isMobile ? st(classes.mobileIconContainer) : ''}
          ref={isMoveAction ? ref : null}
        >
          {isMoveAction && actionButton ? (
            <MoveWrapper
              shown={open === true}
              handleOnCloseMove={() => setOpen && setOpen(false)}
            >
              {actionButton}
            </MoveWrapper>
          ) : (
            actionButton
          )}
        </div>
      );
    });
  };
  return (
    <div
      className={
        isMobile
          ? st(classes.mobileActionsToolBarContainer)
          : st(classes.actionsToolBarContainer)
      }
    >
      {generateActionsToolBarItems()}
    </div>
  );
});

export default withMemberAuthorization(
  withClickOutsideListener(ActionsToolBar),
);
